export class Theme {
  private theme: { [p: string]: string } = {
    fontFamily: "",
    primaryColor: "",
    primaryBackgroundColor: "",
    secondaryColor: "",
    secondaryBackgroundColor: "",
    selectedColor: "",
  };
  private isLandscape = false;

  public setTheme(theme: { [key: string]: string }): void {
    this.theme = theme;
  }
  public setLandscapeMode(isLandscape: boolean): void {
    this.isLandscape = isLandscape;
  }

  public getHostStyle(maxWidth: string) {
    const hostStyle = {
      "background-color": this.theme.secondaryBackgroundColor,
      color: this.theme.secondaryColor,
      width: "100%",
      "max-width": maxWidth,
    };

    return this.optionalFontFamily(hostStyle);
  }

  public getSubHostStyle() {
    const hostStyle = {
      color: this.theme.secondaryColor,
    };

    return this.optionalFontFamily(hostStyle);
  }

  public getInputStyle() {
    return {
      color: this.theme.primaryColor,
      "background-color": this.theme.primaryBackgroundColor,
    };
  }

  public getLinkStyle() {
    return {
      color: this.theme.primaryColor,
    };
  }

  public getIconStyle() {
    return {
      fill: this.theme.primaryColor,
    };
  }

  public getPrimaryButtonStyle() {
    return this.optionalFontFamily({
      color: this.theme.secondaryBackgroundColor,
      "background-color": this.theme.primaryColor,
    });
  }
  public getSecondaryButtonStyle() {
    return this.optionalFontFamily({
      border: `1px solid ${this.theme.primaryColor}`,
      color: this.theme.primaryColor,
      "background-color": this.theme.secondaryBackgroundColor,
    });
  }

  public getOptionsStyle() {
    return this.optionalFontFamily({
      "background-color": this.theme.secondaryBackgroundColor,
      border: `1px solid ${this.theme.primaryBackgroundColor}`,
    });
  }

  public getHighlightedOptionStyle() {
    return this.optionalFontFamily({
      "background-color": this.theme.selectedColor,
    });
  }

  public getContentStyle() {
    return this.optionalFontFamily({
      "background-color": this.theme.primaryBackgroundColor,
    });
  }

  public getContentSecondaryStyle() {
    return this.optionalFontFamily({
      "background-color": this.theme.secondaryBackgroundColor,
    });
  }

  public getSectionContainerClass() {
    return this.isLandscape && "row--landscape";
  }

  public getSectionClass(colSize: number) {
    if (this.isLandscape) {
      return `col-${colSize}--landscape col-${colSize}--spaced section--no-margin`;
    }

    return "section--margin";
  }

  private optionalFontFamily(style) {
    const fontFamily = this.theme.fontFamily;

    if (fontFamily) {
      return {
        ...style,
        "font-family": fontFamily,
      };
    }
    return style;
  }
}

const defaultTheme = new Theme();
export { defaultTheme as theme };
